import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { computeText } from '@/locales/utils';
import { Input } from '@/components/atoms/Form/Input';
import { SVGIcons } from '@/components/atoms/Icon/SVGIcon';
import { SearchContainer, SearchIcon } from './SearchBar.style';

export type SearchBarProps = {
    value: string;
    onChange: (value: string) => void;
    onEnter?: (value: string) => void;
    placeholder?: string;
    icon?: SVGIcons | null;
};

export const SearchBar: React.FunctionComponent<React.PropsWithChildren<SearchBarProps>> = ({
    value,
    onChange,
    onEnter,
    placeholder,
    icon = SVGIcons.MAGNIFY,
    ...otherProps
}) => {
    const intl = useIntl();
    const withIcon = icon !== null;

    const onKeyPressed: React.KeyboardEventHandler = useCallback(
        ({ key }) => {
            if (onEnter && key === 'Enter') {
                onEnter(value);
            }
        },
        [value, onEnter],
    );

    return (
        <SearchContainer data-testid="searchbar-container" {...otherProps} withIcon={withIcon} onKeyDown={onKeyPressed}>
            {withIcon && <SearchIcon icon={icon} size={20} />}
            <Input
                data-testid="searchbar-input"
                value={value}
                onChange={({ target }) => onChange(target.value)}
                placeholder={computeText(intl, placeholder)}
                type="text"
            />
        </SearchContainer>
    );
};
